/**
 * TanStack Query hooks for `custom-url-scheme`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customUrlSchemeQueryKeys,
	type CreateCustomUrlSchemeBody,
	type ListCustomUrlSchemeResponse,
	type CustomUrlSchemeRow,
} from "./api";

export function useCustomUrlSchemeList(): UseQueryResult<ListCustomUrlSchemeResponse, Error> {
	return useQuery({
		queryKey: customUrlSchemeQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomUrlSchemeCreate(): UseMutationResult<CustomUrlSchemeRow, Error, CreateCustomUrlSchemeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customUrlSchemeQueryKeys.all });
		},
	});
}

export function useCustomUrlSchemeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customUrlSchemeQueryKeys.all });
		},
	});
}
